module.exports = __webpack_public_path__ + "static/descriptive-box-3fcce01094f247ab765f0c87b06dab5e.png";